<template>
  <m-dialog ref="dlg" @save="save" :title="instansi && instansi.id ? 'Ubah Seri' : 'Tambah Seri'">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="12" md="10" lg="8" xl="8">
        <v-form @submit.prevent data-vv-scope="form" lazy-validation>
          <v-card flat class="pb-5 mb-5">
            <v-row class="px-5 pt-5">
              <v-col cols="12" class="pb-0 mb-0">
                <m-alert show :title="alert.instansi.form.judul" :info="alert.instansi.form.deskripsi" closable></m-alert>
              </v-col>
            </v-row>
            <v-card-text class="px-5">
              <v-row wrap>
                <v-col cols="12">
                  <p class="title primary--text">Informasi Instansi</p>
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    id="kode"
                    outlined
                    dense
                    autocomplete="false"
                    name="Kode Seri"
                    placeholder="Isikan Kode Seri"
                    label="Kode"
                    v-model="instansi.kode"
                    persistent-hint
                    data-vv-name="kode"
                    data-vv-as="Kode"
                    v-validate="'required'"
                    :error-messages="errors.collect('form.kode')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    id="nama-seri"
                    outlined
                    dense
                    autocomplete="false"
                    name="Nama Periode"
                    placeholder="Nama Periode"
                    label="Nama Periode"
                    v-model="instansi.nama"
                    persistent-hint
                    data-vv-name="seri"
                    data-vv-as="Seri"
                    v-validate="'required'"
                    :error-messages="errors.collect('form.seri')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    id="logo"
                    outlined
                    dense
                    single-line
                    autocomplete="false"
                    name="Logo"
                    placeholder="contoh: http://gb.storage.id/img/logo-seri.png"
                    label="Tautan Logo"
                    v-model="instansi.cover"
                    persistent-hint
                    data-vv-name="cover"
                    data-vv-as="Logo"
                    v-validate="''"
                    :error-messages="errors.collect('form.cover')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    id="url-portal"
                    outlined
                    dense
                    autocomplete="false"
                    name="URL Portal"
                    placeholder="URL Portal"
                    label="URL Portal"
                    v-model="instansi.url_portal"
                    persistent-hint
                    data-vv-name="url_portal"
                    data-vv-as="URL Portal"
                    v-validate="''"
                    :error-messages="errors.collect('form.url_portal')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6" v-if="false">
                  <v-radio-group v-model="instansi.is_mobile" class="mt-0">
                    <template v-slot:label>
                      <div class="black--text">Mendukung Aplikasi Mobile <strong>Ayo Guru Belajar</strong></div>
                    </template>
                    <v-radio :value="1" id="radio-1">
                      <template v-slot:label>
                        <div>Iya</div>
                      </template>
                    </v-radio>
                    <v-radio :value="0" id="radio-2">
                      <template v-slot:label>
                        <div>Tidak</div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <p class="title primary--text mb-0 pb-0" v-if="!instansi.id && false">Konfigurasi LMS (Learndash)</p>
              <span class="caption error--text pb-1 mb-1" v-if="!instansi.id && false">Mohon tidak mengubah data Konfigurasi LMS Berikut</span>
              <v-row v-if="instansi && instansi.wordpress && false">
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    id="nama_lms"
                    outlined
                    dense
                    autocomplete="false"
                    name="Nama LMS"
                    placeholder="Nama LMS"
                    label="Nama LMS"
                    v-model="instansi.wordpress.nama"
                    persistent-hint
                    data-vv-name="nama_lms"
                    data-vv-as="Nama LMS"
                    v-validate="''"
                    :error-messages="errors.collect('form.nama_lms')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    id="url_lms"
                    outlined
                    dense
                    autocomplete="false"
                    name="url LMS"
                    placeholder="url LMS"
                    label="url LMS"
                    v-model="instansi.wordpress.url_lms"
                    persistent-hint
                    data-vv-name="url_lms"
                    data-vv-as="url LMS"
                    v-validate="''"
                    :error-messages="errors.collect('form.url_lms')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    id="wordpress_url"
                    outlined
                    dense
                    autocomplete="false"
                    name="Url LMS"
                    placeholder="url LMS"
                    label="URL LMS"
                    v-model="instansi.wordpress.url"
                    persistent-hint
                    data-vv-name="url_lms"
                    data-vv-as="URL LMS"
                    v-validate="''"
                    :error-messages="errors.collect('form.url_lms')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    id="username"
                    :disabled="instansi.id ? true : false"
                    outlined
                    dense
                    autocomplete="false"
                    name="Username LMS"
                    placeholder="Username LMS"
                    label="Username LMS"
                    v-model="instansi.wordpress.username"
                    persistent-hint
                    data-vv-name="username"
                    data-vv-as="Username LMS"
                    v-validate="''"
                    :error-messages="errors.collect('form.username')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    id="api_token"
                    :disabled="instansi.id ? true : false"
                    outlined
                    dense
                    autocomplete="false"
                    name="TOKEN LMS"
                    placeholder="Masukkan token LMS"
                    label="TOKEN LMS"
                    v-model="instansi.wordpress.api_token"
                    persistent-hint
                    data-vv-name="api_token"
                    data-vv-as="TOKEN LMS"
                    v-validate="''"
                    :error-messages="errors.collect('form.api_token')"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <v-radio-group v-model="instansi.is_rilis" class="mt-0">
                    <template v-slot:label>
                      <div class="black--text title primary--text">Rilis</div>
                    </template>
                    <v-radio :value="1" id="radio-1">
                      <template v-slot:label>
                        <div>Iya</div>
                      </template>
                    </v-radio>
                    <v-radio :value="0" id="radio-0">
                      <template v-slot:label>
                        <div>Tidak</div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <v-radio-group v-model="instansi.is_default" class="mt-0">
                    <template v-slot:label>
                      <div class="black--text title primary--text">Highlight Kegiatan</div>
                    </template>
                    <v-radio :value="1" id="radio-1">
                      <template v-slot:label>
                        <div>Iya</div>
                      </template>
                    </v-radio>
                    <v-radio :value="0" id="radio-0">
                      <template v-slot:label>
                        <div>Tidak</div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <v-radio-group v-model="instansi.is_tutup" class="mt-0">
                    <template v-slot:label>
                      <div class="black--text title primary--text">Tutup</div>
                    </template>
                    <v-radio :value="1" id="radio-1">
                      <template v-slot:label>
                        <div>Iya</div>
                      </template>
                    </v-radio>
                    <v-radio :value="0" id="radio-0">
                      <template v-slot:label>
                        <div>Tidak</div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
import { ALERT_INFO } from "@/const";
export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {},

  data() {
    return {
      instansi: {
        wordpress: {
          nama: "",
          url: "url ",
          api_token: "",
          username: ""
        }
      },
      defInstansi: {
        wordpress: {
          nama: "",
          url: "url ",
          api_token: "",
          username: ""
        }
      },
      alert: ALERT_INFO,
      current_page: 1,
      page: null,
      cp: 1
    };
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.instansi = obj ? { ...obj } : { ...this.defInstansi };
      let x = this.$refs.dlg.open();
      this.$validator.reset();
      return x;
    },

    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store
            .dispatch("instansi/form", this.instansi)
            .then(res => {
              this.$refs.dlg.resolve();
              return res;
            })
            .catch(e => e);
        })
        .catch(e => e);
    }
  }
};
</script>
